// extracted by mini-css-extract-plugin
export var sideBySide = "SideBySide-module--sideBySide--a9904";